import useExtensionAwareNetworks from './useExtensionAwareNetworks'

export default useExtensionAwareNetworks
